<template>
    <div>
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Manage Users</h1>
                <div @click="hideModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
            <div class="w-full flex">
                <div class="modal-toolbar flex items-center justify-between">
                    <div v-if="$gate.isAdmin() || $gate.isClientAdmin()" class="flex items-center">
                        <div v-if="$gate.isAdmin()">
                            <label for="client" class="pt-0">Client</label>
                            <select v-model="selectedClientId" name="client" class="form-select form-select-blue">
                                <option value="">Select Client</option>
                                <option v-for="client in clients.all" :key="client.id" :value="client.id">{{ client.name }}</option>
                            </select>
                        </div>
                        <div v-if="users.all.length"  class="flex items-center ml-4">
                            <div>
                                <label for="user" class="pt-0">User</label>
                                <select v-model="selectedUserId" name="user" class="form-select form-select-blue">
                                    <option value="">Select User</option>
                                    <option v-for="user in users.all" :key="user.id" :value="user.id">{{ user.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div v-if="$gate.isAdmin() || $gate.isClientAdmin()">
                        <button @click.prevent="createUser" class="flex items-center btn btn-small btn-indigo">
                            <inline-svg name="add" classes="w-4 h-4 text-white fill-current"></inline-svg>
                            <span class="ml-2">Create User</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex">
            <div class="modal-sidebar">
                <ul>
                    <li @click="section = 'user-info'">
                        <span :class="{ highlighted: section == 'user-info' }">User Info</span>
                    </li>
                    <li v-if="selectedUserId && selectedUserId !== 'new'" @click="section = 'project-permissions'">
                        <span :class="{ highlighted: section == 'project-permissions' }">Project Permissions</span>
                    </li>
                    <li v-if="selectedUserId && selectedUserId !== 'new'" @click="section = 'site-permissions'">
                        <span :class="{ highlighted: section == 'site-permissions' }">Site Permissions</span>
                    </li>
                    <li v-if="selectedUserId && selectedUserId !== 'new'" @click="section = 'module-permissions'">
                        <span :class="{ highlighted: section == 'module-permissions' }">Module Permissions</span>
                    </li>
                </ul>
            </div>

            <div class="w-full h-full" style="min-height: 600px;">
                <div v-show="section == 'user-info'" class="w-full h-full">
                    <div v-if="! selectedClientId" class="text-center my-10">
                        <span class="text-xl">Select a Client</span>
                    </div>
                    <div v-else-if="! users.all.length" class="flex flex-col items-center justify-center my-10">
                        <span class="none-found">No Users Found</span>
                    </div>
                    <div v-else-if="users.all && ! selectedUserId" class="text-center my-10">
                        <span class="text-xl">Select a User</span>
                    </div>
                    <div v-else>
                        <user-info></user-info>
                    </div>
                </div>

                <div v-show="section == 'settings'" class="w-full">
                    <user-settings></user-settings>
                </div>

                <!-- Permission Sections -->
                <div v-show="section == 'project-permissions'" class="w-full p-6">
                    <project-permissions :user-id="selectedUserId"></project-permissions>
                </div>

                <div v-show="section == 'site-permissions'" class="w-full p-6">
                    <site-permissions :user-id="selectedUserId"></site-permissions>
                </div>

                <div v-show="section == 'module-permissions'" class="w-full p-6">
                    <module-permissions 
                        :user-id="selectedUserId"
                        permission-group="module"
                    ></module-permissions>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import ProjectPermissions from './permissions/ProjectPermissions.vue';
    import SitePermissions from './permissions/SitePermissions.vue';
    import ModulePermissions from './permissions/ModulePermissions.vue';

    export default {
        components: {
            ProjectPermissions,
            SitePermissions,
            ModulePermissions,
        },

        props: {
            clientId: {
                type: Number,
                required: false,
            },

            userId: {
                type: Number,
                required: false,
            },

            selectedSection: {
                type: String,
                default: 'user-info'
            }
        },

        data() {
            return {
                section: this.selectedSection,
                selectedClientId: this.clientId || '',
                selectedUserId: this.userId || '',
            }
        },

        created() {
            // pull clients
            if (this.$gate.isAdmin() && ! this.clients.all) {
                axios.get('/api/clients').then((response) => {
                    this.clients.all = response.data;
                }).catch((error) => {
                    console.log(error);
                });
            }

            if (! this.$gate.isAdmin() && ! this.$gate.isClientAdmin()) {
                this.selectedUserId = window.user.id;
            }

            // pull requested user
            if (this.selectedUserId) {
                this.users.selectedUser = _.find(this.users.all, ['id', this.selectedUserId])
            }
        },

        watch: {
            selectedClientId() {
                this.selectedUserId = '';
                this.users.all = this.client.users;
            },

            selectedUserId() {
                this.users.selectedUser = _.find(this.users.all, ['id', this.selectedUserId]) || '';
            }
        },

        computed: {
            ...mapState(['clients']),
            ...mapState(['users']),

            client() {
                return _.find(this.clients.all, ['id', this.selectedClientId]);
            },

            aUserIsSelected() {
                return this.selectedUserId != 'new' && this.selectedUserId != '';
            }
        },

        methods: {
            createUser() {
                this.users.all.push({
                    id: 'new',
                    client_id: this.selectedClientId,
                    role: {},
                    country_id: 16
                });

                this.selectedUserId = 'new';

                this.section = 'user-info';
            },
        }
    }
</script>
